// update along with app/lib/enums/product_enrichment_resources_file_type.py
const ProductEnrichmentResourcesFileType = {
  PRODUCT_URLS: 'product_urls',
  PRODUCT_DATA: 'product_data',
  PDF_FILE: 'pdf_file',
};

const ProductEnrichmentResourcesFileTypeLabels = {
  PRODUCT_URLS: 'product urls',
  PRODUCT_DATA: 'product data',
  PDF_FILE: 'pdf file',
};

export { ProductEnrichmentResourcesFileType, ProductEnrichmentResourcesFileTypeLabels };
